const readMoreContainer = document.querySelector('.collection-hero__description__banner');
const readMoreBtn = document.querySelector('.collection-hero__description__banner__button');

if (readMoreBtn) {
  readMoreBtn.addEventListener('click', function () {
    readMoreContainer.classList.toggle('collection-hero__description__banner--gradient');
    if (readMoreContainer.classList.contains('collection-hero__description__banner--gradient')) {
      readMoreBtn.textContent = 'read more';
    } else {
      readMoreBtn.textContent = 'read less';
    }
  });
}
